import {
  ACTION_DELETE_CUSTOM_TAG__REQUEST,
  ACTION_DELETE_CUSTOM_TAG__SUCCESS,
  ACTION_DELETE_CUSTOM_TAG__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_DELETE_CUSTOM_TAG__REQUEST:
    case ACTION_DELETE_CUSTOM_TAG__SUCCESS:
      return null;

    case ACTION_DELETE_CUSTOM_TAG__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
